<template>

  <v-system-bar v-if="show && uid !== undefined && uid !== null" app >
    <v-tooltip bottom>

      <span slot="activator">
          <v-btn flat :to="{name: 'Dashboard'}"><v-icon class="mr-1">{{$vuetify.icons.back}}</v-icon>Seller Dashboard
            <v-icon :color="$vuetify.theme.primary" class="ml-1">{{$vuetify.icons.info}}</v-icon>
          </v-btn>

      </span>
      <span>Buyers do not see this. This appears because you're logged in as the seller.</span>
    </v-tooltip>
    <v-spacer></v-spacer>
    <v-btn icon @click="closeBar"><v-icon dark>{{$vuetify.icons.close}}</v-icon></v-btn>
  </v-system-bar>


</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'BackToDashboard',
  components: {
  },
  computed: {
    ...mapState({
      uid: (state) => state.admin.uid,
    }),
  },
  data () {
    return {
      show: true
    }
  },
  methods: {
    closeBar: function () {
      this.show = false
    }
  }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
